<template>
  <div class="statsContainer">
    <span class="top">
      <h6>Inventory Tally</h6>          
      <b-button v-if="!inventoryLoading" class="m-0 p-0" variant="outline-none" size="sm" @click="handleRefresh">
        <b-icon-arrow-counterclockwise></b-icon-arrow-counterclockwise>
      </b-button>
      <div v-if="inventoryLoading" class="spinner-border spinner-border-sm" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </span>
    <ul class="statsList">
      <li>Total: <b-badge variant="secondary" pill>{{ stats.totalItems.toLocaleString('en-US') }}</b-badge></li>
      <li>Unique: <b-badge variant="secondary" pill>{{ stats.unique.toLocaleString('en-US') }}</b-badge></li>
      <li>Active: <b-badge variant="secondary" pill>{{ stats.active.toLocaleString('en-US') }}</b-badge></li>
      <li>Inactive: <b-badge variant="secondary" pill>{{ stats.inactive.toLocaleString('en-US') }}</b-badge></li>
    </ul>
  </div>
</template>

<script>
import statsApi from "@/api/stats";
import utils from "@/mixins/utils";

export default {
  name: 'InventoryTally',
  mixins: [statsApi, utils],
  data() {
    return {
      stats: {
        totalItems: 0,
        unique: 0,
        active: 0,
        inactive: 0,
      },
      inventoryLoading: false,
    };
  },
  mounted() {
    this.getStats();
  },
  methods: {
    async getStats() {
      this.inventoryLoading = true;
      try {
        const inventoryCountStats = await this.fetchTotalInventoryCounts();
        this.stats = inventoryCountStats;
      } catch (err) {
        console.log(err, 'Inventory Stats');
      } finally {
        this.inventoryLoading = false;
      }
    },
    async handleRefresh() {
      this.inventoryLoading = true;
      try {
        const inventoryCountStats = await this.refreshTotalInventoryCounts();
        this.stats = inventoryCountStats;
      } catch (err) {
        console.log(err, 'Inventory Stats');
      } finally {
        this.inventoryLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.statsList {
  font-size: 14px;
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  align-items: center;
  justify-content: center;
  gap: 10px;
}
.statsContainer {
  border: 1px solid #ddd;
  background: #eee;
  padding: 6px;
  border-radius: 4px;
  max-width: max-content;
}
.top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
li {
  margin: 0;
  padding: 0;
}
</style>
